// extracted by mini-css-extract-plugin
export default {"arrow":"tooltip-module__arrow___o6yzf","content":"tooltip-module__content___Jx0jO"};